import { schema } from 'normalizr';

import constants from './constants';

const commentSchema = new schema.Entity(constants.NAME);
export const commentListSchema = [commentSchema];
